/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import Syphon from 'backbone.syphon';
import Ladda from 'ladda';
import { View } from 'backbone.marionette';

import { validateForm } from '@/util/ParsleyUtils';
import showErrorMessage from '@/util/showErrorMessage';

import SubmitAWPackage from '../../services/SubmitAWPackage';

import tmplAWPackageSubmissionModalView from './AWPackageSubmissionModalView.hbs';

const AWPackageSubmissionModalView = View.extend({
  template: tmplAWPackageSubmissionModalView,

  ui: {
    form: '.submit-aw-package-form',
    summary: '[name="summary"]',
    btnSubmit: '.btn-submit',
    btnCancel: '.btn-cancel'
  },

  events: {
    'click @ui.btnCancel': 'onClickCancel',
    'click @ui.btnSubmit': 'onClickSubmit'
  },

  triggers: {
    'modal:close': 'modal:close'
  },

  onRender() {},

  onClickCancel(e) {
    e.preventDefault();
    this.triggerMethod('modal:close', false);
  },

  async onClickSubmit(e) {
    e.preventDefault();
    const spinner = Ladda.create(this.ui.btnSubmit[0]);
    spinner.start();
    this.$el?.find('[role="progressbar"]')?.attr('aria-label', 'Loading');

    try {
      await validateForm(this.ui.form);
    } catch (error) {
      showErrorMessage({
        errorCode: 'validationError',
        errorTitle: 'Validation Error',
        errorMessage: 'There are validation errors submitting the AW Package. Please fix and try again.'
      });
      spinner.stop();
      return;
    }

    const { summary } = Syphon.serialize(this.ui.form);
    const awPackageId = this.model.get('awPackageId');
    this.ui.summary.prop('disabled', true);

    try {
      await SubmitAWPackage(awPackageId, summary);
      this.triggerMethod('modal:close', true);
    } catch (err) {
      this.showSubmissionError(awPackageId);
    } finally {
      spinner.stop();
      this.ui.summary.prop('disabled', false);
    }
  },

  showSubmissionError(packageId) {
    showErrorMessage({
      errorCode: 'submissionError',
      errorTitle: 'Submission Error',
      errorMessage: `There was an error submitting AW Package ${packageId}. Please try again or contact an administrator if the issue persists.`
    });
  }
});

export default AWPackageSubmissionModalView;
